import { useEffect } from "react";
import { Link } from "react-router-dom";
import Cards from "../../components/Cards";
import Header from "../../components/Header";
import * as S from "./styled";
import ReactPixel from 'react-facebook-pixel';
import { useTranslation } from 'react-i18next';

import Homem from "../../assets/Img/H/h1.webp";
import Mulher from "../../assets/Img/M/m1.webp";
import Footer from "../../components/Footer";

export default function Home() {
    const { t } = useTranslation();

    useEffect(() => {
        ReactPixel.track('ViewContent', { action: 'escolher genero' });
    }, []);

    return (
        <S.Container>
            <Header />
            <S.SubContainer>
                <S.Title>
                    {t('home_title')}
                </S.Title>
                <S.Description>
                    {t('home_description')}
                </S.Description>

                <S.Content>
                    <Link style={{ textDecoration: 'none' }} to='/quiz?gender=homem'>
                        <Cards
                            title={t('home_man')}
                            img={Homem}
                        />
                    </Link>
                    <Link style={{ textDecoration: 'none' }} to='/quiz?gender=mulher'>
                        <Cards
                            title={t('home_woman')}
                            img={Mulher}
                        />
                    </Link>
                </S.Content>
            </S.SubContainer>
            <Footer />
        </S.Container>
    );
}
